<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getHotels">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="hotels"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index" width="50px"></el-table-column>
      <el-table-column
        prop="tzName"
        width="200px"
        label="同舟酒店名"
      ></el-table-column>
      <el-table-column
        prop="dltName"
        width="200px"
        label="代理通酒店名"
      ></el-table-column>
      <el-table-column
        prop="tcName"
        width="200px"
        label="同程酒店名"
      ></el-table-column>
      <el-table-column
        prop="pigName"
        width="200px"
        label="飞猪酒店名"
      ></el-table-column>
      <el-table-column label="结算方式" width="200">
        <template slot-scope="s">
          <p>{{ getPay(s.row) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        width="200px"
        label="地址"
      ></el-table-column>
      <el-table-column label="人员" width="100px">
        <template slot-scope="s">
          {{
            s.row.clerks.map((i) => `${roleMap[i.role]}:${i.name}`).join("\n")
          }}
        </template>
      </el-table-column>
      <el-table-column label="销售员" width="100px">
        <template slot-scope="s">
          {{ s.row.sales.map((i) => `${i.name}`).join("\n") }}
        </template>
      </el-table-column>
     
      <el-table-column label="操作" width="150" fixed="right">
        <template scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="handleDel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="同舟酒店名" prop="tzName">
          <el-input v-model="editForm.tzName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="代理通酒店名" prop="dltName">
          <el-input v-model="editForm.dltName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="同程酒店名" prop="tcName">
          <el-input v-model="editForm.tcName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="飞猪酒店名" prop="tcName">
          <el-input v-model="editForm.pigName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="editForm.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="pay">
          <el-select v-model="editForm.pay">
            <el-option :value="1" label="日结"></el-option>
            <el-option :value="2" label="周结"></el-option>
            <el-option :value="3" label="月结"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="同舟酒店名" prop="tzName">
          <el-input v-model="addForm.tzName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="代理通酒店名" prop="dltName">
          <el-input v-model="addForm.dltName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="同程酒店名" prop="tcName">
          <el-input v-model="addForm.tcName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="飞猪酒店名" prop="tcName">
          <el-input v-model="addForm.pigName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="addForm.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="结算方式" prop="pay">
          <el-select v-model="addForm.pay">
            <el-option :value="1" label="日结"></el-option>
            <el-option :value="2" label="周结"></el-option>
            <el-option :value="3" label="月结"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
import NProgress from "nprogress";
import { hotelApi } from "../../api/api";
import { roleMap } from "../../constant";
export default {
  data() {
    return {
      roleMap,
      filters: {
        name: "",
      },
      hotels: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      //编辑界面数据
      editForm: {
        tzName: "",
        address: "",
        id: "",
        dltName: "",
        tcName: "",
        pay: "",
        pigName: '',
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        tzName: [
          { required: true, message: "请输入同舟平台名称", trigger: "blur" },
        ],
        dltName: [
          {
            required: true,
            message: "请输入代理通平台名称",
            trigger: "blur",
          },
        ],
        tcName: [
          {
            required: true,
            message: "请输入同程平台名称",
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
      editFormRules: {
        tzName: [
          { required: true, message: "请输入同舟平台名称", trigger: "blur" },
        ],
        dltName: [
          {
            required: true,
            message: "请输入代理通平台名称",
            trigger: "blur",
          },
        ],
        tcName: [
          {
            required: true,
            message: "请输入同程平台名称",
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        tzName: "",
        dltName: "",
        tcName: "",
        address: "",
        pigName: '',
      },
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getHotels();
    },
    getPay(row) {
      const e = {
        1: "日结",
        2: "周结",
        3: "月结",
      };
      return e[row.pay] || "-";
    },
    //获取用户列表
    getHotels() {
      let para = {
        page: this.page,
        name: this.filters.name,
      };
      this.listLoading = true;
      NProgress.start();
      hotelApi.list(para).then((res) => {
        this.total = res.data.count;
        this.hotels = res.data.rows;
        this.listLoading = false;
        NProgress.done();
      });
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          NProgress.start();
          let para = { id: row.id };
          hotelApi.del(para).then((res) => {
            this.listLoading = false;
            NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getHotels();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign(this.editForm, row);
    },
    //显示新增界面
    handleAdd: function () {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        address: "",
        tcName: "",
        pay: "",
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            hotelApi
              .update(para)
              .then((res) => {
                //NProgress.done();
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getHotels();
              })
              .finally((_) => {
                this.editLoading = false;
              });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            //   para.birth =
            //     !para.birth || para.birth == ''
            //       ? ''
            //       : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
            hotelApi.add(para).then((res) => {
              this.addLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getHotels();
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      var ids = this.sels.map((item) => item.id).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };
          batchRemoveUser(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getHotels();
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getHotels();
  },
  created() {
    // this.roleMap = roleMap;
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// index.vue?e90d9e4e